import { call, put, select } from "redux-saga/effects";
import { setStatusType } from "services/StatusType/actions";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { getStatusTypeRequest } from "./api";
import { statusTypeSelector } from "./selectors";

const statusTypesSchema = new schema.Entity("status_types", undefined , { idAttribute: "code" });
const statusTypesListSchema = new schema.Array(statusTypesSchema);

function* getStatusTypeWorker() {
    try {
        const { codes } = yield select(statusTypeSelector);
        if(!codes.length){
            yield put(setStatusType({ isLoadingStatusType: true }));
            const { status_types } = yield call(getStatusTypeRequest);
            const { result, entities } = normalize(status_types, statusTypesListSchema);
            yield put(setStatusType({
                isLoadingStatusType: false,
                statusTypes: entities.status_types,
                codes: result
            }));
        }
    } catch (error) {
        yield put(setStatusType({ isLoadingStatusType: false }));
        showError(error);
    }
}

export function* getStatusType() {
    yield call(getStatusTypeWorker);
}
